<template>
    <div class="results-body">
        <div class="results-table" v-if="aineResults.length > 0">
            <label class="input-label">{{ "App.VAKHaku.ResultsLabel" | translate }} "{{ searchedText }}" ({{ aineResults.length }} {{ "App.VAKHaku.ResultsLabel.Amount" | translate }})</label>
            <table>
                <thead>
                    <tr>
                        <th>{{ "App.VAKHaku.ResultsTable.Header.UN" | translate }}</th>
                        <th>{{ "App.VAKHaku.ResultsTable.Header.NameAndDescription" | translate }}</th>
                        <th>{{ "App.VAKHaku.ResultsTable.Header.Class" | translate }}</th>
                        <th>{{ "App.VAKHaku.ResultsTable.Header.ClassCode" | translate }}</th>
                        <th>{{ "App.VAKHaku.ResultsTable.Header.PackageGroup" | translate }}</th>
                        <th>{{ "App.VAKHaku.ResultsTable.Header.DangerNumber" | translate }}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(aine, index) in aineResults" :key="index" class="ainetable-row" @click="showDetails(aine.ykNro)">
                        <td>{{ aine.ykNro }}</td>
                        <td>{{ aine.nimi }}</td>
                        <td>{{ aine.luokka }}</td>
                        <td>{{ aine.luokituskoodi }}</td>
                        <td>{{ aine.pakkausryhma }}</td>
                        <td>{{ aine.vaaranTunnusnro }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="no-results" v-else-if="aineResults.length === 0 && searchedText.length > 0 && !loading">
            <p>{{ "App.VAKHaku.NoSearchResults" | translate }} "{{ searchedText }}"</p>
        </div>
    </div>
</template>

<script lang="ts">
    import { Component, Vue } from "vue-property-decorator"
    import AineModel from "../models/aineModel"

    @Component
    export default class VAKHakuResults extends Vue {
        showDetails(ykNro: string): void {
            this.$router.push({ name: "VAKAine", params: { ykNro } })
        }

        get aineResults(): Array<AineModel> {
            return this.$store.getters.vakSearchResults
        }

        get searchedText(): string {
            return this.$store.getters.vakSearchValue
        }

        get loading(): boolean {
            return this.$store.getters.isLoading
        }
    }
</script>

<style scoped>
    .results-body {
        margin: 0px 30px;
    }

    .search-block {
        width: 100%;
        max-width: 1000px;
        padding: 20px 40px;
        background-color: rgb(242, 244, 248);
        text-align: left;
        border-top: 7px solid rgb(2, 98, 115);
    }

        .search-block .input-row {
            margin-bottom: 15px;
        }

        .search-block .full-width {
            width: 100%;
        }

        .search-block .input-group {
            width: 100%;
        }

        .search-block .wide-search {
            max-width: 600px;
            width: 80%;
        }

        .search-block .search-button {
            height: 50px;
            max-width: 50px;
            width: 20%;
            border-radius: 0 2px 2px 0;
            border: 1px solid #026273;
            background-color: #026273;
            color: white;
        }

    .results-table {
        width: 100%;
        max-width: 1400px;
        margin-top: 35px;
        margin-bottom: 150px;
    }

        .results-table .input-label {
            width: 100%;
            text-align-last: left;
        }

        .results-table thead tr {
            height: 50px;
        }

        .results-table th {
            text-align: center;
            border: 1px solid #ECEFF4;
            white-space: nowrap;
            background-color: #026273;
            color: white;
            padding-left: 8px;
            padding-right: 8px;
        }

        .results-table tbody tr:hover {
            background-color: rgba(2, 98, 115, 0.3);
            cursor: pointer;
        }
</style>
